import _extends from 'babel-runtime/helpers/extends';

// import Vue from 'vue'
// import { IData, IMethods, IComputed, IProps } from './tag-ids'
import TagCascaderMulti from '../TagCascaderMulti/index.vue';
export default {
  props: {
    config: {
      default: function _default() {
        return {};
      }
    },
    formValue: {
      default: function _default() {
        return {};
      }
    },
    model: {
      default: function _default() {
        return {};
      }
    },
    resourceType: Number
  },
  data: function data() {
    // console.log(model)
    return {
      // disabaled: true
      // value: model[config.prop]
    };
  },

  computed: {
    tagIds: function tagIds() {
      return this.formValue[this.config.prop];
    },
    formModel: function formModel() {
      return {
        tagIds: this.formValue[this.config.prop],
        applyAll: this.formValue.applyAll
      };
    },
    layout: function layout() {
      return [{
        rowAttrs: {
          type: 'flex',
          justify: 'start',
          align: 'center'
        },
        col: [{
          colAttrs: { col: 12 },
          fields: ['tagIds']
        }, {
          colAttrs: {
            col: 12
          },
          fields: ['applyAll']
        }]
      }];
    },
    schema: function schema() {
      var _this = this;

      return {
        type: 'object',
        properties: {
          tagIds: {
            component: TagCascaderMulti,
            field: {
              params: {
                type: this.config.resourceType
              },
              listeners: _extends({}, this.$listeners, {
                change: function change(value) {
                  _this.$emit('change', value, _this.model.$index);
                }
              })
            }
          },
          applyAll: {
            component: 'checkbox-group',
            field: {
              options: [{
                value: true,
                label: '应用至所有'
              }],
              disabled: this.tagIds.length === 0,
              listeners: {
                change: function change(value) {
                  _this.$emit('applyAllChange', {
                    value: !value,
                    index: _this.model.$index,
                    tagIds: _this.tagIds
                  });
                }
              }
            }
          }
        }
      };
    }
    // m() {
    //   const { model, config } = this.$attrs
    //   console.log(model[config.prop])
    //   return model[config.prop]
    // }

  },
  mounted: function mounted() {
    console.log(this.config);
  }
};